import { Stack } from '@src/common/components/Stack';
import { Typography } from '@src/common/components/Typography';
import { theme } from '@src/common/styles/Theme';
import type { CollapseListener } from '@src/orders/CollapseListener';
import type { AxleSummary } from '@src/orders/domain/AxleSummary';
import type { Order } from '@src/orders/domain/Order';
import { AxleSubSectionGroup } from '@src/orders/PermitFormSections/axlesConfiguration/AxleSubSectionGroup';
import { AxleSummarySubSection } from '@src/orders/PermitFormSections/axlesConfiguration/AxleSummarySubSection';
import { AxleWeightField } from '@src/permitField/AxleInformationFields';
import { useTranslation } from 'react-i18next';

type Props = {
  axleSummary: AxleSummary;
  isLoading?: boolean;
  fields: string[];
  order: Order;
} & CollapseListener;

export const AxleInformationSectionContent = (props: Props) => {
  const { t } = useTranslation();

  const shouldDisplaySummarySection = props.fields.includes(
    AxleWeightField.fieldName,
  );
  return (
    <Stack gap={theme.spacing['3']}>
      <Typography component="h2" variant="h5">
        {t('axleInformation')}
      </Typography>
      {props.axleSummary.axleGroup.length === 0 && (
        <Typography>{t('noVehicleInformation')}</Typography>
      )}
      {props.axleSummary.axleGroup.map((axleGroup, i) => (
        <AxleSubSectionGroup
          key={`axle-group-${i}-information`}
          cumulativeAxleCount={props.axleSummary.axlesCountUpTo(i)}
          axleGroup={axleGroup}
          groupIndex={i}
          isLoading={props.isLoading}
          fields={props.fields}
          order={props.order}
        />
      ))}
      {shouldDisplaySummarySection && (
        <AxleSummarySubSection
          collapseEventName={props.collapseEventName}
          uncollapseEventName={props.uncollapseEventName}
        />
      )}
    </Stack>
  );
};
